/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_PrintInputs */



/**
* | output |
* | --- |
* | "Print" |
*
* @param {Checkin_Qr_PrintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_print = /** @type {((inputs?: Checkin_Qr_PrintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_PrintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Imprimer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imprimir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Imprimir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stampa")
	return /** @type {LocalizedString} */ ("Print")
});